/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_Sources_TitleInputs */

const es_walkthrough_settings_sources_title = /** @type {(inputs: Walkthrough_Settings_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes de Datos`)
};

const en_walkthrough_settings_sources_title = /** @type {(inputs: Walkthrough_Settings_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Sources`)
};

/**
* | output |
* | --- |
* | "Data Sources" |
*
* @param {Walkthrough_Settings_Sources_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_sources_title = /** @type {((inputs?: Walkthrough_Settings_Sources_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_Sources_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_sources_title(inputs)
	return en_walkthrough_settings_sources_title(inputs)
});
export { walkthrough_settings_sources_title as "walkthrough.settings_sources_title" }